export function isAddressDetailsValid(addressDetailsState) {
  const {
    isPostcodeValid,
    isAddressLine1Valid,
    isCityValid,
    isCountyValid,
  } = addressDetailsState;
  return isPostcodeValid && isAddressLine1Valid && isCityValid && isCountyValid;
}
